// extracted by mini-css-extract-plugin
module.exports = {"DateWrapper":"Date_DateWrapper__2v8ri"};